// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: true,
    websiteUrl: 'https://demo.ecomsys.online',
    apiUrl: 'https://api.ecomsys.online',
    fileUrl: 'https://img.ecomsys.online',
    pageSize: 5,
    origin: '*',
    project: 'ecomsys',
    project_title: 'EcomSys',
    multilanguage: true,
    multicurrency: true,

    // Default language settings
    defaultLanguage: 'EN',
    defaultDirection: 'ltr',
    defaultCurrency: 'USD',
    defaultCurrencyDisplay: '$',

    defaultLanguages: [
        { name: 'English', image: 'language-1', dir: 'ltr', symbol: 'EN' },
        { name: 'فارسی', image: 'language-2', dir: 'rtl', symbol: 'FA' }
    ],
    
    defaultCurrencies: [
        { name: '$ US Dollar', url: '', code: 'USD', symbol: '$' },
        { name: '€ Euro', url: '', code: 'EUR', symbol: '€' }
    ]
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.